// cookie操作工具

/**
 * 设置Cookie
 * @param {string} name - Cookie名称
 * @param {string} value - Cookie值
 * @param {number} [days=7] - 过期天数，默认7天
 * @param {string} [path='/'] - Cookie路径，默认根路径
 */
export function setCookie(name, value, days = 7, path = '/') {
  const expires = new Date()
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)

  // 拼接 Cookie 字符串
  let cookieValue = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
  cookieValue += `; expires=${expires.toUTCString()}`;
  cookieValue += `; path=${path}`;

  document.cookie = cookieValue
}

/**
 * 获取Cookie
 * @param {string} name - Cookie名称
 * @returns {string|null} - Cookie值，如果不存在则返回null
 */
export function getCookie(name) {
  const nameEQ = name + '='
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length))
  }
  return null
}

/**
 * 删除Cookie
 * @param {string} name - Cookie名称
 * @param {string} [path='/'] - Cookie路径，默认根路径
 */
export function removeCookie(name, path = '/') {
  setCookie(name, '', -1, path)
}



// WEBPACK FOOTER //
// ./src/assets/js/cookie.js